export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8266.792a3c15.jpg";